import type { Dictionnaire } from '../type';

export const legal: Dictionnaire['legal'] = {
  documents: {
    cgu: 'شروط الاستخدام',
    confidentialite: 'سياسة الخصوصية',
    mentions: 'الإشعار القانوني',
    version: (v: string) => `الإصدار ${v}`,
  },
  consentement: {
    titrePlusieurs: 'تغيّرت وثائقنا',
    titreUn: 'تغيّرت إحدى الوثائق',
    textePlusieurs: 'لمواصلة استخدام Sirocco، اقرأ الوثيقتين أدناه ووافق عليهما.',
    texteUn: 'لمواصلة استخدام Sirocco، اقرأ الوثيقة أدناه ووافق عليها.',
    accepter: 'الموافقة والمتابعة',
    deconnecter: 'تسجيل الخروج',
  },
  ecran: {
    resumeCgu: 'ما توافق عليه عند استخدامك Sirocco.',
    resumeConfidentialite: 'ما البيانات التي تُجمع، ولماذا، وإلى متى.',
    resumeMentions: 'من ينشر التطبيق، ومن يستضيفه، وكيف تتواصل معنا.',
    titre: 'الشروط والخصوصية',
    accepte: (cgu: string, confidentialite: string, quand: number | null) =>
      `وافقتَ على الإصدار ${cgu} من شروط الاستخدام والإصدار ${confidentialite} من سياسة الخصوصية${quand ? ` بتاريخ ${new Date(quand).toLocaleDateString('ar-u-nu-latn')}` : ''}.`,
  },
  lien: {
    impossible: 'تعذّر فتح الصفحة. هذا هو العنوان:',
  },
  miseAJour: {
    texte: 'يتضمّن هذا الإصدار تغييرات لا يستطيع التطبيق تثبيتها بنفسه.',
    plusTard: 'لاحقًا',
    mettreAJour: 'تحديث',
    disponible: (version: string) => `Sirocco ${version} متاح`,
  },
};
